const ACCEPTED_ATTACHMENT_TYPES = [
  '.pdf',
  '.docx',
];

export default ACCEPTED_ATTACHMENT_TYPES;
